import { Component, OnInit, ViewChild, ElementRef, TemplateRef } from '@angular/core';
import { ConnectionService } from '../../connection.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import * as Highcharts from 'highcharts';
import { ToastrService } from 'ngx-toastr';
import { WalletserviceService } from '../../services/walletservice.service';
import { element } from 'protractor';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-representatives',
  templateUrl: './representatives.component.html',
  styleUrls: ['./representatives.component.css']
})
export class RepresentativesComponent implements OnInit {
  listSR = []; tot: number = 1; nietos = []; nextRound: any;
  chartColor = (localStorage.getItem("Sastana-Theme") == 'darktheme') ? '#000000' : null;
  dep: number = 1
  timeString: string = '';

  @ViewChild('SRForm') SRForm: TemplateRef<any>;

  governanceObj: any = {}
  srDetailsList: any;
  srCounts: any = {};
  charts = [];
  modalRef: BsModalRef;
  balance: any;
  disableStatus: boolean;
  address: string;
  token: string;
  isExists: any;
  checkWitness: any;
  signLoader = false;
  networkParameters: any;
  totalVotes: number;
  isSRexists: any;
  srStatus: any;
  disableSr: boolean;
  totalProduced: number;


  constructor(private conn: ConnectionService, public http: HttpClient,
    private alert: ToastrService, public hc: WalletserviceService, private modalService: BsModalService, private router: Router, private spinner: NgxSpinnerService) {
    this.getnextmaintenancetime();
    this.conn.coinBalance.subscribe((res: any) => {
      this.balance = res
      if (this.balance < 10000) {
        this.disableSr = true
      }
      else {
        this.disableSr = false
      }
    })

  }

  ngOnInit() {
    this.address = localStorage.getItem('Address')
    this.token = localStorage.getItem('Sastana_Token')
    setTimeout(() => {
      this.Srdetails()
      this.getSR();
      this.SrInfo();
      this.getSRInfo()
      this.getnetworkParams();
    }, 1000)
    setTimeout(() => {
      this.calculateTimeRemaining();
    }, 3000);
  }

  sendModal() {
    if (this.token != null) {
      this.modalRef = this.modalService.show(this.SRForm);
    }
    else {
      this.router.navigate(['/login'])
    }
  }

  getnetworkParams() {
    this.conn.postUrl('adminNew/getRewardSpec', {}).subscribe((res: any) => {
      this.networkParameters = res.data
    })
  }

  getSR() {
    this.spinner.show()
    this.conn.getUrl('superRep/getAllWitness').subscribe((res: any) => {
      this.spinner.hide()
      this.listSR = res.data;
      for (var j = 0; j < this.listSR.length; j++) {
        // this.nextRound = this.listSR[0].nextRound;
        this.listSR[j].position = j + 1;
        this.listSR[j].random = Math.floor(Math.random() * 2);
        var totalProduced = this.listSR[j].totalProduced;
        var totalMissed = this.listSR[j].totalMissed;
        var name = this.listSR[j].address;
        var count = this.listSR[j].voteCount;
        var obj = {};
        obj["name"] = name
        obj["y"] = totalProduced;
        obj["missed"] = totalMissed
        this.nietos.push(obj);
      }
      this.createPieChart()
      this.conn.clearbackground();

    });
  }

  createPieChart() {
    Highcharts.chart('chart-pie', {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie'
      },
      title: {
        text: '',
        style: {
          color: 'white',
        }
      },
      tooltip: {
        pointFormat: '<br>Blocks produced : <b>{point.y}</b><br/><br>Blocks Missed : <b>{point.missed}</b><br/>'
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            style: {
              color: 'black'
            }
          },
        }
      },
      series: [{
        name: 'Blocks',
        colorByPoint: true,
        innerSize: '50%',
        // color: '#2740a6',
        data: this.nietos
      }]
    } as any);
  }

  getnextmaintenancetime() {
    // this.spinner.show()
    this.conn.postUrl('contract/getTime', {}).subscribe((res: any) => {
      // this.spinner.hide()
      this.nextRound = res.data
    });
  }

  calculateTimeRemaining() {
    const currentTime = new Date().getTime();
    const timeDifference = this.nextRound - currentTime
    if (timeDifference > 0) {
      const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
      this.timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      setTimeout(() => {
        this.calculateTimeRemaining();
      }, 1000);
    } else {
      // this.timeString = 'Timer expired!';
    }
  }

  Srdetails() {
    this.conn.getUrl('superRep/getAllWitness').subscribe(async (res: any) => {
      this.srDetailsList = res.data;
      this.isSRexists = await this.srDetailsList.filter(((item: any) => item.address == this.address))
      var sum = 0; var totalBlockCount = 0; var srpercentperBlock = 0
      for (let i = 0; i < this.srDetailsList.length; i++) {
        sum += this.srDetailsList[i].voteCount;
        // totalBlockCount += this.srDetailsList[i].totalProduced
        // srpercentperBlock = this.srDetailsList[i].totalProduced / totalBlockCount * 100
        // console.log("🚀 ~ RepresentativesComponent ~ this.conn.getUrl ~ srpercentperBlock:", srpercentperBlock)
        // console.log("🚀 ~ RepresentativesComponent ~ this.conn.getUrl ~ totalBlockCount:", totalBlockCount)
      }
      this.totalVotes = sum
      // this.totalProduced = totalBlockCount
      // console.log("🚀 ~ RepresentativesComponent ~ this.conn.getUrl ~ this.totalProduced:", this.totalProduced)
      
    });
  }

  SrInfo() {
    this.conn.getUrl('superRep/getSrDetails').subscribe((res: any) => {
      this.srCounts = res.data[0];
    });
  }

  getSRInfo() {
    this.conn.postUrl('superRep/getAppliedSrbyaddress', { address: this.address }).subscribe((res: any) => {
      if (res.data != null) {
        this.srStatus = res.data?.SRstatus;
      }
      else {
        this.srStatus = '';
      }
    });
  }

  createWitness() {
    this.signLoader = true
    this.conn.postUrl('superRep/applySr', { address: this.address, url: this.governanceObj.url }).subscribe((res: any) => {
      if (res.status == true) {
        this.modalRef.hide();
        this.alert.success(res.msg);
        this.signLoader = false
        window.location.reload()
      }
      else {
        this.alert.error(res.msg);
        this.signLoader = false
      }
    })
  }

  copyText(val: string) {
    let selBox = document.createElement('input');
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.alert.success('Copied to the clipboard');
  }
}
